import React, { useContext, useState } from "react";
import { DSOContext } from "../../../context/DSOContext";
const DSOListing = ({currentPage,perPage}) => {
  const { loading, DSOList, setShowCreateModal, setEditData, fetchDSOs } =
    useContext(DSOContext);
  const editDSO = (data) => {
    setEditData(data);
    setShowCreateModal(true);
  };
  const [sortColumn, setSortColumn] = useState(null); // holds active sort column
  const [sortAsc, setSortAsc] = useState(true); // holds direction

  const handleSort = (key) => {
    const isSameColumn = sortColumn === key;
    const newSortAsc = isSameColumn ? !sortAsc : true; // if clicking again toggle, else default to asc
    setSortColumn(key);
    setSortAsc(newSortAsc);
    fetchDSOs(key, newSortAsc ? "asc" : "desc");
  };


  return (
    <>
      <div className="card-body">
        {loading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="w-100 table-responsive">
            <div id="example_wrapper" className="dataTables_wrapper">
              <table id="example" className="display w-100 dataTable">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("name")}
                    >
                      DSO Full Name
                      {sortColumn === "name" ? (sortAsc ? "⬆" : "⬇") : "⬆⬇"}
                    </th>
                    <th>Email Id</th>
                    <th>Contact Number</th>
                    <th>Password</th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("state_id")}
                    >
                      State
                      {/* {sortColumn === "state_id" ? (sortAsc ? "⬆" : "⬇") : "⬆⬇"} */}
                    </th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("district_id")}
                    >
                      District
                      {sortColumn === "district_id"
                        ? sortAsc
                          ? "⬆"
                          : "⬇"
                        : "⬆⬇"}
                    </th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {DSOList?.data?.length > 0 ? (
                    DSOList?.data?.map((data, index) => {
                      //   const serialNumber = (1 - 1) * 10 + (index + 1);
                      // const serialNumber = index + 1;
                      return (
                        <tr key={index}>
                          <td>{index + 1 + (currentPage - 1) * perPage}</td>
                          {/* <td>{data?.registration_id}</td> */}
                          {/* <td>{data?.id}</td> */}
                          <td>{data?.name}</td>
                          <td>{data?.email}</td>
                          <td>{data?.phone}</td>
                          <td>{data?.decrypted_password || data?.org_pwd}</td>
                          <td>{data?.state?.name}</td>
                          <td>{data?.district?.name}</td>
                          <td
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              editDSO(data);
                            }}
                          >
                            <i class="bi bi-pencil-square"></i>
                          </td>
                          {/* <td>{formatDateTime(data?.created_at)}</td> */}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        Data is not available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    
    </>
  );
};

export default DSOListing;
